import { useEffect, useState } from 'react'
import { useQuery } from 'hooks/useQuery'

import { useAuthToken } from 'hooks/useAuthToken'

import { Box, Grid, CircularProgress } from '@mui/material'

import { AthleticLogo, BTLogo } from 'assets/icons/config'

import Form from './components/Form'
import Error from './components/Error'

import { PAYMENT_LINK_UUID_NOT_FOUND, PAYMENT_LINK_EXPIRED } from 'components/constants/payment-link'

import { formalizeAdvancePayment, formalizePayment, generateElectronicInvoice, showPaymentLink } from 'services/paymentLink'
import Approved from './components/Approved'
import { getDocumentTypes } from 'services/payments'
// import { getAppToken } from 'services/auth'

const PaymentLink = (props) => {
  const { setCurrentBrand } = props

  const query = useQuery()
  const uuid = query.get('uuid')
  const currentBrand = query.get('b')

  const { getAuthToken } = useAuthToken();

  const [loading, setLoading] = useState(false)
  const [transaction, setTransaction] = useState(false)
  const [messageError, setMessageError] = useState('')
  const [descriptionError, setDescriptionError] = useState(null)
  const [fetchCounter, setFetchCounter] = useState(0)
  const [docTypes, setDocTypes] = useState([])

  const [information, setInformation] = useState()

  const sendInvoice = async (id_invoice) => {
    const { data } = await generateElectronicInvoice({ id_invoice })
  }

  const formalize = async (payload) => {
    // let response_aldp;
    // response_aldp = {} //await formalizeAdvancePayment(payload?.uuid)

    // if (response_aldp?.data?.data?.invoice?.id) {
    //   sendInvoice(response_aldp?.data?.data?.invoice?.id)
    //   return
    // }

    // const { data } = await formalizePayment(payload?.metadata)

    // if (data?.data?.invoice?.id || response_aldp?.data?.data?.invoice?.id) {
    //   sendInvoice(data?.data?.invoice?.id ?? response_aldp?.data?.data?.invoice?.id)
    //   return
    // }

    // setMessageBody('Se produjo un error formalizando tu pago, comunicate con servicio al cliente usando la referencia ' + payload?.payment_link?.id)
    return
  }


  const fetchData = async () => {
    setFetchCounter(prev => prev + 1)
    try {
      const response = await showPaymentLink(uuid)
      if (response.data.status === 'success' && response?.data?.data?.uuid) {
        const { data: { data } } = response

        setInformation(data)
        setTransaction(!!data.transaction)

        if ([3, '3', 'Aprobado'].includes(data?.transaction?.transaction_status)) {
          formalize(data)
        }

        return;
      }

      setMessageError('Ha ocurrido un error')
      setDescriptionError('Por favor recarga la pagina para obtener la información del pago')
      return

    } catch (error) {
      const expired = error.response.data.data.message === 'Lo sentimos, el link de pago ha caducado, por favor solicita uno nuevo.'

      setMessageError(expired ? PAYMENT_LINK_EXPIRED.message : PAYMENT_LINK_UUID_NOT_FOUND.message)
      setDescriptionError(expired ? PAYMENT_LINK_EXPIRED.description : error.response.data.data.message)
      return

    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    setCurrentBrand(currentBrand)

    localStorage.setItem("current_brand", currentBrand);

    if (!uuid || !['1', '2', '3'].includes(currentBrand)) {
      setMessageError(PAYMENT_LINK_UUID_NOT_FOUND.message)
      setDescriptionError(PAYMENT_LINK_UUID_NOT_FOUND.description)
      return
    }

    ; (async () => {
      setLoading(true)
      await getAuthToken()
      await fetchData()
      const { data } = await getDocumentTypes()
      if (data?.status === 'success') {
        setDocTypes(data?.data)
      }
    })()
  }, [])

  if (loading) {
    return (
      <Box maxWidth="100%" height="98vh" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box maxWidth="100%" height="98vh">
      <Grid container spacing={2} py={{ xs: 2, md: 3 }} px={{ xs: 3, md: 12 }}>
        <Grid item xs={12} container justifyContent={{ xs: 'center', md: 'flex-start' }}>
          {['1', '3'].includes(currentBrand) ? <BTLogo /> : <AthleticLogo />}
        </Grid>

        {transaction ? (
          <Approved information={information} />
        ) : (
          messageError ? <Error message={messageError} description={descriptionError} /> : <Form docTypes={docTypes} currentBrand={currentBrand} information={information} />
        )}
      </Grid>
    </Box>
  )
}

export default PaymentLink
